import { Radio, Space } from 'antd';
import DatePicker from 'react-datepicker2';

import { types_list } from '../../Credit';
// icons
import { ReactComponent as CancelIcon } from './../../../../../../assets/svg/cancel.svg';
import styles from './CreditFilterSidebar.module.css';

const CreditFilterSidebar = ({
  type,
  set_type,
  price_from,
  set_price_from,
  price_to,
  set_price_to,
  date_from,
  set_date_from,
  date_to,
  set_date_to,
  sidebar_open,
  set_sidebar_open,
  submit_filter
}) => (
  <>
    {/* sidebar */}
    <div className={`${styles.Sidebar} ${sidebar_open ? styles.Active : ''}`}>
      <div className={styles.SidebarFiltersContainer}>
        {/* close icon */}
        <div
          className={styles.CancelIconContainer}
          onClick={() => {
            set_sidebar_open(false);
            set_type(1);
            set_date_from(null);
            set_date_to(null);
            set_price_from('');
            set_price_to('');
          }}>
          <CancelIcon className={styles.CancelIcon} />
        </div>

        {/* type collapse */}
        <div className={styles.Collapse}>
          <div className={styles.CollapseHeader}>
            <span className={`${styles.PriceLabel}mb-0`}>نوع</span>
          </div>
          <Radio.Group onChange={(e) => set_type(e.target.value)} value={type}>
            <Space direction="vertical">
              {types_list.map((type_item) => (
                <Radio key={type_item.key} value={type_item.value}>
                  {type_item.label}
                </Radio>
              ))}
            </Space>
          </Radio.Group>
        </div>

        {/* price */}
        <div className={styles.PriceContainer}>
          <label className={styles.PriceLabel}>مبلغ</label>
          <div className={styles.InputsContainers}>
            <div className={`${styles.InputParent} ${styles.LeftPadding}`}>
              <input
                onChange={(e) => set_price_from(e.target.value)}
                placeholder="12000 تومان"
                value={price_from}
              />
              <span className={styles.InputsLabel}>از</span>
            </div>
            <div className={`${styles.InputParent} ${styles.RightPadding}`}>
              <input
                onChange={(e) => set_price_to(e.target.value)}
                placeholder="500000 تومان"
                value={price_to}
              />
              <span className={styles.InputsLabel}>تا</span>
            </div>
          </div>
        </div>

        <div className={styles.Seprator} />

        {/* Date container */}
        <div className={styles.PriceContainer}>
          <label className={styles.PriceLabel}>تاریخ</label>
          <div className={styles.InputsContainers}>
            <div className={`${styles.InputParent} ${styles.LeftPadding}`}>
              <DatePicker
                inputJalaaliFormat="jYYYY-jMM-jDD"
                isGregorian={false}
                onChange={(value) => set_date_from(value)}
                timePicker={false}
                value={date_from}
              />
              <span className={styles.InputsLabel}>از</span>
              <div className={styles.DateClear} onClick={() => set_date_from(null)}>
                <CancelIcon />
              </div>
            </div>

            <div className={`${styles.InputParent} ${styles.RightPadding}`}>
              <DatePicker
                inputJalaaliFormat="jYYYY-jMM-jDD"
                isGregorian={false}
                onChange={(value) => set_date_to(value)}
                timePicker={false}
                value={date_to}
              />
              <span className={styles.InputsLabel}>تا</span>
              <div className={styles.DateClear} onClick={() => set_date_to(null)}>
                <CancelIcon />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.Seprator} />
      </div>

      {/* submit button */}
      <div className={styles.SubmitContainer}>
        <button
          className={styles.SubmitButton}
          onClick={() => {
            submit_filter(false);
            set_sidebar_open(false);
          }}
          type="button">
          فیلتر کن
        </button>
      </div>
    </div>

    {/* backdrop of sidebar */}
    <div
      className={`${styles.Backdrop} ${sidebar_open ? styles.Active : ''}`}
      onClick={() => {
        set_sidebar_open(false);
        set_type(1);
        set_date_from(null);
        set_date_to(null);
        set_price_from('');
        set_price_to('');
      }}
    />
  </>
);

export default CreditFilterSidebar;
